import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { LoaderComponent, LoaderIcon, LoaderWrapper } from './style';

const Loader = ({ isLoading }) =>
  isLoading ? (
    <LoaderWrapper>
      <LoaderComponent>
        <LoaderIcon />
      </LoaderComponent>
    </LoaderWrapper>
  ) : (
    <></>
  );

Loader.propTypes = {
  isLoading: PropTypes.bool
};

export default connect(({ app }) => ({ isLoading: app.isLoading }))(Loader);
